import { i18n } from 'common/hooks/useI18n/useI18n.hook';

import { FuturePositionAddTPSLPopupProps } from './FuturePositionAddTPSL.component';
import { FuturePositionAddTPSLPopupContainer } from './FuturePositionAddTPSL.container';

export default (props: FuturePositionAddTPSLPopupProps) => ({
  component: <FuturePositionAddTPSLPopupContainer {...props} />,
  hideCloseIcon: props.hideCloseIcon,
  closeOnClickOutside: false,
  useBottomSheet: true,
  title: (translate: i18n['translateToText']) => translate('mobile:derivative:position:details:order:partialss'),
  wrapperClassName: 'derivative-order-edit-popup',
  ...props,
});
